<ng-container *ngIf="showScan">
    <div class="icon-div" #excludeDiv (click)="OnScanPress(qrScannerModal,$event)">
        <div class="scan-text">
            Scan here
        </div>
        <img [src]="qrcodeImg" [ngClass]="{'rotate-animation': showScan}" class="scan-anime" alt="">

    </div>
</ng-container>
<ng-template #qrScannerModal let-modal>
    <div class="modal-header">
        <h5 class="modal-title">Scan QR Code</h5>
        <button type="button" class="close" (click)="onClose()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <mat-slide-toggle (click)="toggleTorch()">Torch: {{torchEnabled}}</mat-slide-toggle>

        <div class="form-group mt-2" *ngIf="currentDevice">
            <label for="" class="mb-1">Choose Camera</label>
            <select class="form-control mb-1" (change)="onDeviceSelectChange($event.target.value)">
                <option value="" [selected]="!currentDevice">No Device Selected</option>
                <option *ngFor="let device of availableDevices" [value]="device.deviceId"
                    [selected]="currentDevice && device.deviceId === currentDevice.deviceId">{{device.label}}</option>
            </select>
        </div>

        <!-- QR scanner component here -->
        <div class="scanner-container absolute inset-0 flex flex-col min-w-0 overflow-hidden">

            <zxing-scanner (scanSuccess)="onScanSuccess($event)" [torch]="torchEnabled" [(device)]="currentDevice"
                [tryHarder]="tryHarder" (permissionResponse)="onHasPermission($event)"
                (camerasFound)="onCamerasFound($event)" (torchCompatible)="onTorchCompatible($event)"></zxing-scanner>


            <div *ngIf="isContainerVisible" class="rectangle-overlay">
                <div class="line" [style.top.%]="linePosition"></div>
            </div>
        </div>
    </div>

</ng-template>